import React from 'react';
import styles from '../../../styles/components/forms/BookingForm.module.css';
import { TrustpilotWidget } from '../../common';

const FormHeader = ({ isDarkMode }) => {
    return (
        <>
        <div className={styles['form-header-container']}>
            <p className={`${styles['form-header']} ${isDarkMode ? styles['form-header-dark'] : ''}`} id="booking-form-title">
                Get An Instant Quote
            </p>
        </div>
        <div className="col-lg-6 d-block d-lg-none">
        <div className="d-flex flex-column">
            <div className="text-start mb-0">
                <TrustpilotWidget />
            </div>
        </div>
    </div>
        </>
    );
};

export default FormHeader;
